import { COUNTRIES, COUNTRIES_OPTIONS } from 'react-easyrocket';

const exclusions = new Set([
  'AFG',
  'BLR',
  'KHM',
  'CHN',
  'CUB',
  'ETH',
  'IRN',
  'IRQ',
  'PRK',
  'LAO',
  'LBN',
  'LBY',
  'MMR',
  'PAK',
  'PSE',
  'RUS',
  'WSM',
  'SAU',
  'SOM',
  'SYR',
  'UKR',
  'UMI',
  'YEM',
  'CUW',
  'BVT',
  'ATF',
  'HMD',
  'UMI'
]);

export const COUNTRIES_OPTIONS_FOR_REG = COUNTRIES_OPTIONS.filter((el) => !exclusions.has(el.id));

export const allCountriesForReg = COUNTRIES.filter((el) => !exclusions.has(el.alpha3));
export const PRAGMATIC_PROVIDER_ID = 49;
export const PRAGMATIC_LIVE_PROVIDER_ID = 96;
